import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#94A3B8",
  d: "M10 5.833V2.5H1.667v15h16.667V5.833zm-5 10H3.334v-1.666H5zM5 12.5H3.334v-1.667H5zm0-3.333H3.334V7.5H5zm0-3.334H3.334V4.167H5zm3.334 10H6.667v-1.666h1.667zm0-3.333H6.667v-1.667h1.667zm0-3.333H6.667V7.5h1.667zm0-3.334H6.667V4.167h1.667zm8.333 10H10v-1.666h1.667V12.5H10v-1.667h1.667V9.167H10V7.5h6.667zM15 9.167h-1.666v1.666H15zm0 3.333h-1.666v1.667H15z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }